module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"priceEstimationError":"There was an error generating the price profitability estimation"},"es":{"priceEstimationError":"Hubo un error generando la estimación de rentabilidad de precios"}}')
  delete Component.options._Ctor
}
